import type { DisplayMode, PopupInstance, DisplayConfig } from '../types';

export class BannerDisplayMode implements DisplayMode {
	createContainer(popup: PopupInstance): HTMLElement {
		const { display, feedId } = popup.config;
		const position = display.bannerPosition || 'top';

		const wrapper = document.createElement('div');
		wrapper.className = `gf-popups-banner gf-popups-banner--${position} ${display.customCssClass}`;
		wrapper.dataset.feedId = String(feedId);
		wrapper.style.zIndex = String(display.zIndex);
		wrapper.setAttribute('aria-hidden', 'true');

		const inner = document.createElement('div');
		inner.className = 'gf-popups-banner__inner';
		if (display.innerWidth) {
			inner.style.maxWidth = display.innerWidth;
		}

		if (display.showCloseButton) {
			const close = document.createElement('button');
			close.className = 'gf-popups-close';
			close.setAttribute('aria-label', 'Close');
			close.innerHTML = '&times;';
			close.addEventListener('click', () => popup.hide());
			inner.appendChild(close);
		}

		const content = document.createElement('div');
		content.className = 'gf-popups-content';
		inner.appendChild(content);
		wrapper.appendChild(inner);

		return wrapper;
	}

	show(container: HTMLElement, config: DisplayConfig): void {
		container.removeAttribute('aria-hidden');
		requestAnimationFrame(() => {
			container.classList.add('gf-popups-banner--visible');
		});
	}

	async hide(container: HTMLElement, config: DisplayConfig): Promise<void> {
		container.classList.remove('gf-popups-banner--visible');
		container.setAttribute('aria-hidden', 'true');
		await new Promise(resolve => setTimeout(resolve, 300));
	}

	destroy(container: HTMLElement): void {
		container.remove();
	}
}
